<!--
 * @Author: your name
 * @Date: 2019-11-29 05:12:22
 * @LastEditTime: 2019-12-24 15:07:35
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /site-cms/site/src/modules/md-team/carousel-fashion/agent-item.vue
 -->
<template>
    <a
        :href="redirectUrl"
        class="agent-item-container"
        :target="detailUrlTarget"
        rel="noopener noreferrer"
    >
        <img-box
            :src="agentTargetImage || ''"
            :alt="agent.fullName"
            dir="width"
            class="agent-main"
            errorImg="https://cdn.chime.me/image/fs/sitebuild/202457/7/original_fbb918b4-831d-43d3-8d96-68f8986a8e79.png"
        >
            <p class="name">{{ agent.fullName }}</p>
            <div class="agent-info">
                <p class="info-name">{{ agent.fullName }}</p>
                <p v-if="agent.position || agent.license" class="pos-li">
                    <span v-if="agent.position" class="position"
                    >{{ agent.position
                    }}{{ agent.license ? ' ' : '' }}</span
                    >
                    <span v-if="agent.license" class="license"
                    >{{ licenseName }}{{ agent.license }}</span
                    >
                </p>
            </div>
        </img-box>
    </a>
</template>

<script>
import agentInfoMixin from "../agent-info";
export default {
    props: {
        agent: {
            type: Object,
            default: () => ({})
        },
        licenseName: {
            type: String,
            default: ''
        },
        detailUrlTarget: {
            type: String,
            default: '_self'
        }
    },
    mixins: [agentInfoMixin]
};
</script>
